var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 6.375a3.438 3.438 0 1 0 0 6.875 3.438 3.438 0 0 0 0-6.875m0 5a1.562 1.562 0 1 1 0-3.126 1.562 1.562 0 0 1 0 3.126M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m0 18.125a8.07 8.07 0 0 1-4.863-1.632 3.89 3.89 0 0 1 3.465-2.118h2.8c1.475 0 2.786.82 3.464 2.118A8.1 8.1 0 0 1 12 20.125m6.258-2.95c-1.055-1.648-2.852-2.675-4.86-2.675h-2.796c-2.007 0-3.803 1.025-4.86 2.675A8.08 8.08 0 0 1 3.875 12c0-4.48 3.645-8.125 8.125-8.125S20.125 7.52 20.125 12c0 1.965-.703 3.77-1.867 5.176"
  })));
};
export default SvgAccount;